/* eslint-disable no-restricted-syntax, no-restricted-globals */
/* eslint-env es6 */

import {AopsFilter} from "./filter.module.js";

run();

function run() {
	const catalog = document.getElementById("offering");
	if (!catalog) {
		return;
	}
	const catalogFilterClass = "catalog-filter";
	const newFilters = catalog.querySelector(`.${catalogFilterClass}`);
	if (!newFilters) {
		return;
	}

	const storageKey = "courseFilter";
	const catalogClass = `.js-${catalogFilterClass}`;
	const hideClass = "d-none";
	const allCourses = [...document.querySelectorAll(".course")];
	const resultsElem = document.querySelector(`${catalogClass}__results`);
	const subjectSeasonElems = [
		...document.querySelectorAll("[data-season][data-subject]"),
	];
	const gradeElems = [...document.querySelectorAll("[data-grades]")];
	const allElems = [...subjectSeasonElems, ...gradeElems];
	const subjectCbs = [
		...document.querySelectorAll(
			'input[type="checkbox"][data-filter="subject"]'
		),
	];
	const seasonCbs = [
		...document.querySelectorAll(
			'input[type="checkbox"][data-filter="season"]'
		),
	];
	const gradeCbs = [
		...document.querySelectorAll('input[type="checkbox"][data-filter="grade"]'),
	];
	const allCheckboxes = [...subjectCbs, ...seasonCbs, ...gradeCbs];
	const noresultsElm = document.querySelector(".noresults");
	const fadeClass = "fader";
	const fadeOnClass = "fader--fade";
	const fadeables = [...subjectSeasonElems, noresultsElm];
	const toggleable = document.querySelector(`${catalogClass}__toggleable`);

	enableFiltering();

	function isNewFilterDisplayed() {
		return getComputedStyle(newFilters).getPropertyValue("display") !== "none";
	}

	function showAllElements() {
		for (const elem of allElems) {
			elem.classList.remove(hideClass);
		}
	}

	function hideEmptySections() {
		if (!isNewFilterDisplayed()) {
			return;
		}

		for (const elem of subjectSeasonElems) {
			const courses = [...elem.querySelectorAll(".course")];

			if (courses.every(AopsFilter.isHidden)) {
				elem.classList.add(hideClass);
			}
		}
	}

	function countResults() {
		const results = allCourses.filter(AopsFilter.isVisible).length;

		resultsElem.textContent = results;
		noresultsElm.classList.toggle(hideClass, results !== 0);
	}

	/**
	 * Sets the current state of the checkboxes to `sessionStorage` for later
	 * when the user leaves this page and then returns so that it remembers
	 * which filters they left on.
	 */
	function saveState() {
		let checkedCheckboxes = [];

		for (const checkbox of allCheckboxes) {
			if (checkbox.checked) {
				checkedCheckboxes.push(checkbox.id);
			}
		}

		checkedCheckboxes = checkedCheckboxes.join(",");
		sessionStorage.setItem(storageKey, checkedCheckboxes);
	}

	function fade(turnOn = true) {
		for (const fadeable of fadeables) {
			fadeable.classList.toggle(fadeOnClass, turnOn);
		}
		return new Promise((resolve) => setTimeout(resolve, 200));
	}

	async function doFilter() {
		if (!isNewFilterDisplayed()) {
			return;
		}
		await fade();
		showAllElements();

		AopsFilter.filterGrouped(seasonCbs, subjectSeasonElems, "season");
		AopsFilter.filterGrouped(subjectCbs, subjectSeasonElems, "subject");
		AopsFilter.filterGrouped(gradeCbs, gradeElems, "grades");

		hideEmptySections();
		countResults();
		saveState();
		await fade(false);
	}

	function initClearFilterInputs() {
		const clears = [...document.querySelectorAll(`${catalogClass}__clear`)];

		for (const clear of clears) {
			clear.addEventListener("click", () => {
				if (allCheckboxes.every((cb) => !cb.checked)) {
					return;
				}

				for (const checkbox of allCheckboxes) {
					AopsFilter.uncheck(checkbox);
				}
			});
		}
	}

	function listenToToggleButton() {
		const toggle = document.querySelector(`${catalogClass}__toggle`);
		if (!(toggleable || toggle)) {
			return;
		}

		toggle.addEventListener("click", () => {
			toggleable.classList.toggle(hideClass);
		});
	}

	/**
	 * Gets the previous state of the checkboxes from `sessionStorage` to
	 * initialize the filters for the user to what they set last.
	 */
	function loadState() {
		let checkedCheckboxes = sessionStorage.getItem(storageKey);
		if (!checkedCheckboxes) {
			return;
		}
		checkedCheckboxes = checkedCheckboxes.split(",");
		if (checkedCheckboxes.length < 1) {
			return;
		}

		toggleable.classList.remove(hideClass);

		for (const checkboxId of checkedCheckboxes) {
			const checkbox = document.getElementById(checkboxId);
			if (!checkbox) {
				continue;
			}

			AopsFilter.check(checkbox);
		}
	}

	/**
	 * Filter by query parameters, if appropriate.
	 * Returns true if any valid filters were found.
	 */
	function loadQueryParams() {
		let hasQueryParams = false;
		const searchParams = new URLSearchParams(window.location.search);
		for (const [key, value] of searchParams.entries()) {
			// Accept 1, 'true', and 't' as true
			if (!value || !["1", "true", "t"].includes(value.toLowerCase())) {
				continue;
			}

			const checkbox = document.getElementById(`catalog-filter__${key}`);
			if (!checkbox) {
				continue;
			}

			hasQueryParams = true;
			AopsFilter.check(checkbox);
		}

		return hasQueryParams;
	}

	function filtersOn() {
		for (const checkbox of allCheckboxes) {
			checkbox.addEventListener("change", doFilter);
		}
	}

	async function enableFiltering() {
		const total = allCourses.length;
		const totalElem = document.querySelector(`${catalogClass}__total`);

		if (totalElem) {
			totalElem.textContent = total;
		}
		resultsElem.textContent = total;
		listenToToggleButton();
		const hasQueryParams = loadQueryParams();
		// Query parameters should override the stored state.
		if (!hasQueryParams) {
			loadState();
		}
		await doFilter();
		initClearFilterInputs();
		filtersOn();
		for (const fadeable of fadeables) {
			fadeable.classList.add(fadeClass);
		}
		applyLegacyFilter();
		observeDisplayChanges();
	}

	/**
	 * This allows the filter, as well as all of the elements it affects to be
	 * rendered at will.
	 */
	function observeDisplayChanges() {
		const observer = new MutationObserver(function () {
			if (isNewFilterDisplayed()) {
				doFilter();
			} else {
				showAllElements();
			}
		});

		observer.observe(newFilters, {attributes: true});
	}

	/**
	 * Supports the old query parameter filters
	 */
	function applyLegacyFilter() {
		const bucket = new URLSearchParams(location.search).get("filter-bucket");
		if (!bucket) {
			return;
		}

		for (const elem of allCourses) {
			elem.style.display = "";
		}

		for (const elem of subjectSeasonElems) {
			elem.style.display = "";
			if (elem.dataset.filterBucket !== bucket) {
				continue;
			}

			for (const elem2 of subjectCbs) {
				AopsFilter.check(
					elem2,
					elem2.dataset.filterValue === elem.dataset.subject
				);
			}
			for (const elem2 of seasonCbs) {
				const isMatchingSeason =
					elem2.dataset.filterValue === elem.dataset.season;
				AopsFilter.check(elem2, isMatchingSeason);
				if (!isMatchingSeason && elem2.parentElement) {
					elem2.parentElement.remove();
				}
			}
		}
	}
}
